<template>
    <div class="modal-full" v-if="Object.keys(professionalWritingRequest).length > 0">
        <div class="modal-header">
            <close-icon v-on:click="closeView"></close-icon>
            <h1>Professional Writing Request</h1>
        </div>

        <div class="modal-body no-pad">
            <div class="flex h-full">
                <div class="professional-writing-sidebar h-full">
                    <div class="mb-4 text-center">
                        <p class="text-lg font-light">Details</p>
                    </div>
                    <div class="mb-3" v-if="professionalWritingRequest.user">
                        <label>User ID</label>
                        <p>{{ professionalWritingRequest.user.id }}</p>

                        <label>Email</label>
                        <p>
                            <router-link
                                :to="{name: 'users.show', params: {userId: professionalWritingRequest.user.id} }">
                                {{ professionalWritingRequest.user.email }}
                            </router-link>
                        </p>
                    </div>

                    <div class="mb-3">
                        <label>Date</label>
                        <p>{{ formatDateShort(professionalWritingRequest.created_at) }}</p>

                        <label>Payment Date</label>
                        <p>{{ formatDateShort(professionalWritingRequest.paid) }}</p>

                        <label>Telephone</label>
                        <p>{{ professionalWritingRequest.telephone }}</p>
                    </div>

                    <div class="mb-3">
                        <label>Sectors</label>
                        <p v-for="sector in requestSectors">{{ sector }}</p>

                        <label>Locations</label>
                        <p v-for="location in requestLocations">{{ location }}</p>
                    </div>

                    <div class="mb-3"
                         v-if="professionalWritingRequest.press_releases && professionalWritingRequest.press_releases.length">
                        <label>Press Release</label>
                        <p v-for="press_release in professionalWritingRequest.press_releases">
                            <a href="#" @click.prevent="openPressRelease(press_release.pr_id)">{{
                                    press_release.pr_id
                                }}</a>
                        </p>
                    </div>
                </div>

                <div class="professional-writing-body">

                    <div class="form-field">
                        <label>Status</label>
                        <select v-model="professionalWritingRequest.status">
                            <option v-for="(status, index) in statuses" :value="index">
                                {{ status }}
                            </option>
                        </select>
                    </div>

                    <div class="form-field">
                        <label>Business</label>
                        <input type="text" v-model="professionalWritingRequest.business.name" readonly
                               @click="selectFieldContent">
                    </div>

                    <div class="form-field">
                        <label>Subject</label>
                        <input type="text" v-model="professionalWritingRequest.subject" readonly
                               @click="selectFieldContent">
                    </div>

                    <div class="form-field">
                        <label>Quotes</label>
                        <textarea v-model="professionalWritingRequest.quotes" rows="5" readonly
                                  @click="selectFieldContent"></textarea>
                    </div>

                    <div class="form-field">
                        <label>Keywords</label>
                        <input type="text" v-model="professionalWritingRequest.keywords" readonly
                               @click="selectFieldContent">
                    </div>

                    <div class="form-field">
                        <label>Information</label>
                        <textarea v-model="professionalWritingRequest.info" rows="5" readonly
                                  @click="selectFieldContent"></textarea>
                    </div>
                </div>


            </div>
        </div>

        <div class="modal-footer">
            <div class="flex">
                <div class="right text-right">
                    <button class="btn-primary" type="button" v-if="handoverOptionAvailable" @click="openDraftModel">
                        Hand Over to Business
                    </button>
                    <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                    <button class="btn-primary" type="button" @click="saveForm">Save</button>
                </div>
            </div>
        </div>
        <router-view v-slot="{ Component }">
            <transition name="drop-in" mode="in-out">
                <component :is="Component"></component>
            </transition>
        </router-view>
    </div>
</template>

<script>
export default {
    name: 'ProfessionalWritingView',
    data() {
        return {
            professionalWritingRequest: {},
            statuses: [],
            requestSectors: null,
            requestLocations: null,
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        loadData() {
            axios.get(route('professionalWriting.show', this.$route.params.professionalWritingId))
                .then(response => {
                    this.professionalWritingRequest = response.data.professionalWriting
                    this.statuses = response.data.statuses
                    this.requestLocations = response.data.locations
                    this.requestSectors = response.data.sectors
                    this.setMetaTitle(this.professionalWritingRequest.subject + ' | JournoLink Control')
                })
                .catch(e => {
                    this.$bus.$emit('alert.danger', 'Unable to find professional writing request')
                })
        },
        /**
         * update professional writing request
         * @return {void}
         */
        saveForm() {
            axios.put(route('professionalWriting.update', this.$route.params.professionalWritingId),
                this.professionalWritingRequest)
                .then(response => {
                    this.$bus.$emit('alert.success', 'Update Success')
                })
                .catch(e => {
                    console.log(e)
                })
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.setMetaTitle('List Professional Writing Requests | JournoLink Control')
            this.$root.goBack()
        },
        /**
         * Handle an [Escape] keypress
         *
         * @return {void}
         */
        onEscapeKeypress() {
            this.closeView()
        },
        openDraftModel() {
            this.$router.push({
                name: 'professionalWriting.draftPressRelease',
                params: {professionalWritingId: this.$route.params.professionalWritingId}
            })
        },
        openPressRelease(releaseId) {
            this.$router.push({
                name: 'releases.show',
                params: {releaseId: releaseId}
            })
        },

        selectFieldContent(e) {
            e.target.select()
        },
    },
    computed: {
        handoverOptionAvailable: function () {
            let inProgressStatus = _.indexOf(this.statuses, 'In Progress')

            if (_.get(this.professionalWritingRequest, 'status', null) == inProgressStatus) {
                return true
            }

            return false
        }
    }
}
</script>

<style lang="less">
.professional-writing-sidebar {
    padding: 15px;
    width: 350px;
    font-size: 0.9rem;
    background: #f6f6f6;

    label {
        font-weight: bold;
        font-size: 0.8em;
        color: #999999;
    }

    p {
        margin-bottom: 0.5em;
    }
}

.professional-writing-body {
    flex: 1;
    padding: 15px;
}
</style>
